import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const CategoryChart: React.FunctionComponent = (props) => {
    const [total, setTotal] = React.useState(0)
    return (
        <BPMChart {...props} title='Categories' type='doughnut' subTitle={`Total of ${total} downloads`}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/byGroup', options, signal).then((d) => {
                    setTotal(d.reduce((a, b) => a + b.count, 0))
                    return d
                })
            }} additionalParams={{ groupBy: 'category_name' }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: 'category_name',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/CategoryChart.tsx